module.exports = __webpack_public_path__ + "static/assets/b758b8b515eaa0d58bc1f762b99a9444.svg";